import "@inter-ikea-kompis/component-product-list/lib/components/product-list/ProductList.js";
import WrappedComponent from "@inter-ikea-kompis/component-product-list/lib/components/product-list/ProductList.js";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import KompisElementRegistry from '@inter-ikea-kompis/web-component/lib/registry/KompisElementRegistry.js';
class KompisProductList extends React.Component {
    constructor() {
        super(...arguments);
        this.customElements = new KompisElementRegistry();
        this.listeners = {};
        this.ref = {
            current: null
        };
    }
    render() {
        return React.createElement(this.customElements.getInternalName("kompis-product-list"), this.getForwardedProps(), this.props.children);
    }
    componentWillUnmount() {
        this.setState({
            element: null
        });
        this.removeAllListeners(this.ref.current);
        this.ref.current = null;
    }
    componentWillMount() {
        this.customElements.define("kompis-product-list", WrappedComponent);
    }
    removeAllListeners(element) {
        for (const eventType in this.listeners) {
            const callback = this.listeners[eventType];
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, callback);
            }
            delete this.listeners[eventType];
        }
    }
    updateEventListener(element, callback, eventType) {
        if (callback !== this.listeners[eventType]) {
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, this.listeners[eventType]);
            }
            this.listeners[eventType] = callback;
            if (typeof callback === 'function') {
                element.addEventListener(eventType, this.listeners[eventType]);
            }
        }
    }
    getForwardedProps() {
        const forwardedProps = {
            ref: this.onRef.bind(this),
            class: this.props.className,
            'data-element-name': "kompis-product-list"
        };
        for (const key in this.props) {
            if (!(key in this['constructor']['propTypes'])) {
                forwardedProps[key] = this.props[key];
            }
        }
        return forwardedProps;
    }
    onRef(element) {
        if (element === null) {
            return;
        }
        if (element !== this.ref.current && this.ref.current !== null) {
            this.removeAllListeners(this.ref.current);
        }
        this.updateAllEventListeners(element, this.props);
        this.updateAllPropValues(element, this.props);
        this.ref.current = element;
    }
    updateAllPropValues(element, props) {
        element.addable = props.addable;
        element.collectable = props.collectable;
        element.collected = props.collected;
        element.disableLinks = props.disableLinks;
        element.editableQuantity = props.editableQuantity;
        element.expanded = props.expanded;
        element.includedProducts = props.includedProducts;
        element.layout = props.layout;
        element.locale = props.locale;
        element.localizedInformation = props.localizedInformation;
        element.maxHeadingLevel = props.maxHeadingLevel;
        element.measurementSystem = props.measurementSystem;
        element.productLink = props.productLink;
        element.productMeasures = props.productMeasures;
        element.quantityMinValue = props.quantityMinValue;
        element.removable = props.removable;
        element.sections = props.sections;
        element.settings = props.settings;
        element.shoppingProducts = props.shoppingProducts;
        element.showDesignText = props.showDesignText;
        element.showItemNo = props.showItemNo;
        element.showPackageMeasures = props.showPackageMeasures;
        element.showStockStatusOnPrint = props.showStockStatusOnPrint;
        element.showWeight = props.showWeight;
        element.skipListingLabel = props.skipListingLabel;
        element.sortBy = props.sortBy;
        element.storeAvailabilities = props.storeAvailabilities;
        element.storeId = props.storeId;
        element.stores = props.stores;
        element.theme = props.theme;
        element.translations = props.translations;
        element.visibleModal = props.visibleModal;
        element.zipAvailabilities = props.zipAvailabilities;
    }
    updateAllEventListeners(element, props) {
        this.updateEventListener(element, props.onAdd, "add");
        this.updateEventListener(element, props.onCollect, "collect");
        this.updateEventListener(element, props.onExpand, "expand");
        this.updateEventListener(element, props.onModalClose, "modalClose");
        this.updateEventListener(element, props.onModalOpen, "modalOpen");
        this.updateEventListener(element, props.onProductImageClick, "productImageClick");
        this.updateEventListener(element, props.onProductNameClick, "productNameClick");
        this.updateEventListener(element, props.onQuantity, "quantity");
        this.updateEventListener(element, props.onRemove, "remove");
    }
}
KompisProductList.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    addable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    collectable: PropTypes.bool,
    collected: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    disableLinks: PropTypes.bool,
    editableQuantity: PropTypes.bool,
    expanded: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    includedProducts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    layout: PropTypes.string,
    locale: PropTypes.string,
    localizedInformation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    maxHeadingLevel: PropTypes.string,
    measurementSystem: PropTypes.string,
    productLink: PropTypes.string,
    productMeasures: PropTypes.string,
    quantityMinValue: PropTypes.number,
    removable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    sections: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    settings: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    shoppingProducts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    showDesignText: PropTypes.bool,
    showItemNo: PropTypes.bool,
    showPackageMeasures: PropTypes.bool,
    showStockStatusOnPrint: PropTypes.bool,
    showWeight: PropTypes.bool,
    skipListingLabel: PropTypes.string,
    sortBy: PropTypes.string,
    storeAvailabilities: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    storeId: PropTypes.string,
    stores: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    theme: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    translations: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    visibleModal: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    zipAvailabilities: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    onQuantity: PropTypes.func,
    onExpand: PropTypes.func,
    onCollect: PropTypes.func,
    onProductImageClick: PropTypes.func,
    onProductNameClick: PropTypes.func,
    onModalClose: PropTypes.func,
    onModalOpen: PropTypes.func
};
export default KompisProductList;
